import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './NewsPage.css';

const NewsPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const meta = t('news.articleJavilandMeta', { returnObjects: true });
  const paras = t('news.articleJavilandParas', { returnObjects: true });

  const paragraphs = Array.isArray(paras) ? paras : [];
  const metaObj = meta && typeof meta === 'object' && !Array.isArray(meta) ? meta : {};

  return (
    <div className="news-page">
      <div className="news-page-inner">
        <header className="news-page-header">
          <p className="news-page-tag">{t('news.tag')}</p>
          <h1 className="news-page-title">{t('news.title')}</h1>
          <p className="news-page-lead">{t('news.lead')}</p>
        </header>
        <article className="news-article-feature">
          {(metaObj.date || metaObj.readTime || metaObj.author) && (
            <div className="news-article-meta">
              {metaObj.date && <span>{metaObj.date}</span>}
              {metaObj.readTime && (
                <>
                  {(metaObj.date || metaObj.author) ? <span aria-hidden className="news-meta-sep">·</span> : null}
                  <span>{metaObj.readTime}</span>
                </>
              )}
              {metaObj.author && (
                <>
                  {(metaObj.date || metaObj.readTime) ? <span aria-hidden className="news-meta-sep">·</span> : null}
                  <span>{metaObj.author}</span>
                </>
              )}
            </div>
          )}
          <h2 className="news-article-title">{t('news.articleJavilandTitle')}</h2>
          <p className="news-article-lead">{t('news.articleJavilandLead')}</p>
          <div className="news-article-body">
            {paragraphs.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
};

export default NewsPage;
